<div class="aero-image-radio-group">
  <ng-content></ng-content>
</div>

